import { Box, Typography, IconButton, Fade } from '@mui/material'
import { styled, keyframes } from '@mui/material/styles'
import ErrorIcon from '@mui/icons-material/Error'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import InfoIcon from '@mui/icons-material/Info'
import CloseIcon from '@mui/icons-material/Close'
import { useEffect, useState, useRef } from 'react'
import api from '../services/api'

const scroll = keyframes`
    0% { transform: translateX(100%); }
    100% { transform: translateX(-100%); }
  `

const Container = styled(Box)(({ level }) => {
    const colors = {
        critico: 'linear-gradient(90deg, #8b0000, #d32f2f)',
        aviso: 'linear-gradient(90deg, #e65100, #f57c00)',
        informativo: 'linear-gradient(90deg, #0d47a1, #1976d2)',
    }

    return {
        // position: 'absolute',
        left: 170,
        width: '100%',
        height: 25,
        // marginTop: -8,
        background: colors[level] || colors.informativo,
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        padding: '0 16px',
        zIndex: 9999,
        cursor: 'pointer'
    }
})

const ContentWrapper = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'a',
    overflow: 'hidden',
})

const AnimatedText = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'animate',
})(({ animate }) => ({
    whiteSpace: 'nowrap',
    position: 'absolute',
    color: '#fff',
    fontWeight: 500,
    animation: animate ? `${scroll} 20s linear infinite` : 'none',
}))

export default function AlertaFarmacovigilancia({ setControlAlerts }) {
    const [alertas, setAlertas] = useState([])
    const [index, setIndex] = useState(0)
    const [closed, setClosed] = useState(false)
    const [animate, setAnimate] = useState(true)
    const [fadeIn, setFadeIn] = useState(true)
    const textRef = useRef(null)
    const containerRef = useRef(null)

    // Buscar alertas
    useEffect(() => {
        // api.get(`/site-infos?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Lei`)
        api.get(`/site-infos?menu=FARMACOVIGILÂNCIA&opcao=Alerta&pePage=5`)
            .then(res => {
                setAlertas(res.data.siteInfos || [])
                setControlAlerts(res.data.siteInfos)
            })
            .catch(() => { })
    }, [])

    // Rotação com fade
    useEffect(() => {
        if (alertas.length <= 1) return

        const interval = setInterval(() => {
            setFadeIn(false)
            setTimeout(() => {
                setIndex(prev => (prev + 1) % alertas.length)
                setFadeIn(true)
            }, 400)
        }, 25000)

        return () => clearInterval(interval)
    }, [alertas])

    // Verificar se precisa animar
    useEffect(() => {
        if (textRef.current && containerRef.current) {
            const textWidth = textRef.current.offsetWidth
            const containerWidth = containerRef.current.offsetWidth
            setAnimate(textWidth > containerWidth)
        }
    }, [index, alertas])

    if (closed || alertas.length === 0) return null

    const alerta = alertas[index]
    const level = alerta?.nivel || 'aviso'

    const iconMap = {
        critico: <ErrorIcon sx={{ color: '#fff', mr: 1 }} />,
        aviso: <WarningAmberIcon sx={{ color: '#fff', mr: 1 }} />,
        informativo: <InfoIcon sx={{ color: '#fff', mr: 1 }} />
    }

    const handleClick = () => {
        if (alerta?.anexo) {
            // navigate(`/informacoes?menu=FARMACOVIGILÂNCIA&opcao=Alerta`); 
            window.open(alerta?.anexo, "_blank", "noopener,noreferrer");
        }
    }

    // Função para remover tags HTML do conteúdo do alerta 
    const removeHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html')
        return doc.body.textContent || ''
    }


    return (
        <Fade in={fadeIn} timeout={400}>
            <Container
                level={level}
                onClick={handleClick}
            >
                {iconMap[level]}

                <ContentWrapper
                    ref={containerRef}
                    onMouseEnter={() => setAnimate(false)}
                    onMouseLeave={() => setAnimate(true)}
                >
                    <AnimatedText
                        ref={textRef}
                        variant="body2"
                        animate={animate}
                    >
                        {removeHtml(alerta.conteudo)}
                    </AnimatedText>
                </ContentWrapper>

                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        setClosed(true);
                        setControlAlerts('');
                    }}
                    sx={{ color: '#fff', ml: 2 }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Container>
        </Fade>
    )
}
